export default __webpack_public_path__ + "static/media/hero.d480401b.png";